class Validate {
  static warningEmpty = (
    el: React.MutableRefObject<HTMLInputElement | null>
  ) => {
    if (el && el.current) {
      el.current?.classList.add('input--invalid');
      el.current?.addEventListener('animationend', (e) => {
        if (e.animationName === 'shake-invalid') {
          el.current?.classList.remove('input--invalid');
        }
      });
    }
  };
}

export default Validate;
